module.exports = __webpack_public_path__ + "static/chara-6f475644e86d0aa513ca97759bfcb641.png";